module.exports = __webpack_public_path__ + "static/media/sq2.dcae6b69.jpg";